<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="'/Inventory/Issue'"
                        >View Odm Document</router-link
                    >/ PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>Print
                </v-btn>
            </v-col>
        </v-row>
        <div id="printDiv">
            <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
            <div style="margin: 0px !important">
                <v-row>
                    <v-col cols="2" style="margin-left: 1%" class="pa-0">
                        <img
                            src="../../../assets/odm/HPBLUE.png"
                            style="width: 150px"
                        />
                    </v-col>
                    <v-col cols="8" class="pa-0">
                        <div>
                            <span
                                style="
                  font-size: 23px;
                  font-weight: bold;
                  color: black;
                  margin-left: 200px;
                "
                                >CSO (Customer Support Order)</span
                            >
                        </div>

                        <div style="margin-top: 10px; margin-left: 20px">
                            <span
                                style="font-size: 22px; font-weight: bold; color: black"
                            >
                                Hotline 02-787-3344(Pay Phone) or
                                180-029-4207(Free Number)
                            </span>
                        </div>

                        <div>
                            <span
                                style="
                  font-size: 22px;
                  font-weight: bold;
                  color: black;
                  margin-left: 200px;
                "
                                >#1(Thai) Or #2 (Eng) #1#1</span
                            >
                        </div>
                    </v-col>
                    <v-col cols="1" class="pa-0">
                        <right>
                            <img
                                src="../../../assets/odm/QRCODEODM.png"
                                style="width: 150px; text-align: right"
                            />
                        </right>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 25px">
                    <v-col cols="7" class="lighten-3 pa-0">
                        <div class="0">
                            <div
                                class="white"
                                style="font-weight: bold; font-size: 20px; color: black"
                            >
                                HP Inc. (Thailand) Ltd.
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="5" class="lighten-3 pa-0">
                        <div class="0">
                            <div
                                class="white"
                                style="font-weight: bold; font-size: 20px; margin-left: 35px"
                            >
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Job ID:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                    >{{ data_case.caseid }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="7" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white" style="font-size: 20px">
                                3rd Floor, 968 U Chu Liang Building,
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="5" class="lighten-3 pa-0">
                        <div class="0">
                            <div
                                class="white"
                                style="font-weight: bold; font-size: 20px; margin-left: 35px"
                            >
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Cso ID:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                    >{{ data_case.case_id }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="7" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white" style="font-size: 20px">
                                Rama 4 Road, Silom, Bangrak Bangkok
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="5" class="lighten-3 pa-0">
                        <div class="0">
                            <div
                                class="white"
                                style="font-weight: bold; font-size: 20px; margin-left: 35px"
                            >
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Tax No:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                ></span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="7" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white" style="font-size: 20px">
                                Thailand 10500
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="5" class="pa-0">
                        <div class="0">
                            <div class="white"></div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Tel:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 3em"
                                    >(662) 353-9000</span
                                >
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Fax:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 3em"
                                    >(662) 637-5233</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Received:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                    >{{ data_case.created_at }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Started:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                    >{{
                                        data_subcase.onsite_at
                                    }}______________</span
                                >
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Finished:</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 1.3em"
                                    >{{
                                        data_subcase.onsite_at
                                    }}______________</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <hr style="position: relative; border: 1px solid" />
                <v-row>
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Customer Name :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >K.{{ data_case.customer_name }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Company Name :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_subcase.site_name }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Address :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_subcase.site_address }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 10px">
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Email :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_case.customer_email }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Phone/Mobile :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_case.customer_tel }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Fax :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >-</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Model No :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                >
                                    <!-- {{ data_case.model_no }} -->
                                    {{ data_case.product_description }}
                                </span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Serial No :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_case.product_serial }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Product No :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_case.product_no }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Fault Description :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_case.case_title }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 20px">
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Engineer Comment :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                ></span>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >OTC :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ waranty }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 20px">
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 20px; color: black; font-weight: bold"
                                    >Repair Summary :</span
                                >
                                <span
                                    style="font-size: 20px; color: black; padding-left: 0.5em"
                                    >{{ data_subcase.solution }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 20px">
                    <v-col cols="2" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div>
                                    <span
                                        style="font-size: 20px; color: black; font-weight: bold"
                                        >Part No</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div style="margin-left: 7px">
                                    <span
                                        style="font-size: 20px; color: black; font-weight: bold"
                                        >Description</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="3" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div>
                                    <span
                                        style="font-size: 20px; color: black; font-weight: bold"
                                        >Quantity</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-for="(item, index) in data_subcase.parts" :key="index">
                    <v-col cols="2" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div>
                                    <span
                                        style="font-size: 20px; color: black"
                                        >{{ item.part_name }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="6" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div style="margin-left: 7px">
                                    <span
                                        style="font-size: 20px; color: black"
                                        >{{ item.part_description }}</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="3" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <div>
                                    <span
                                        style="font-size: 20px; color: black; margin-left: 38px"
                                        >1</span
                                    >
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 20px">
                    <v-col cols="8" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span
                                    style="font-size: 19px; color: black; font-weight: bold"
                                    >Assigned Engineer :</span
                                >
                                <span
                                    style="font-size: 19px; color: black; margin-left: 15px"
                                    >{{ data_subcase.engineer_name }}
                                    {{
                                        data_subcase.engineer_hp_learnerid
                                    }}</span
                                >
                            </div>
                        </div>
                    </v-col>
                    <!-- <v-col cols="1" class="lighten-3 pa-0">
            <div class="0">
              <div class="white" style="margin-left:10px;">
                <span style="font-size:20px;color:black;padding-left: 0.5em;">{{
                  data_subcase.learnerid
                }}</span>
              </div>
            </div>
          </v-col> -->
                    <v-col cols="4" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="0">
                                <div class="white">
                                    <span
                                        style="font-size: 20px; color: black; font-weight: bold"
                                        >Scheduled :</span
                                    >
                                    <span
                                        style="font-size: 20px; color: black; padding-left: 0.5em"
                                    ></span>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row style="margin-top: 5px">
                    <v-col cols="12" class="lighten-3 pa-0">
                        <div class="0">
                            <div class="white">
                                <span style="font-size: 13px; color: black"
                                    >For HARDWARE SERVICE CENTER
                                    REPAIRING:</span
                                >
                            </div>
                            <div class="white">
                                <span style="font-size: 13px; color: black">
                                    An Evaluation charge of Baht 1,000
                                    (excluding VAT) will be applied to rejected
                                    quotation for all out of warranty jobs
                                </span>
                            </div>
                            <div class="white">
                                <span style="font-size: 13px; color: black"
                                    >For HARDWARE ON-SITE SERVICE
                                    REPAIRING:</span
                                >
                            </div>
                            <div class="white">
                                <span style="font-size: 13px; color: black">
                                    Labor at least Baht 1,700 PLUS travel charge
                                    PLUS after office-hour labor as per approved
                                    “AUTHORIZED REQUEST FOR COMPUTER PRODUCT
                                </span>
                            </div>
                            <div class="white">
                                <span style="font-size: 13px; color: black">
                                    HARDWARE SERVICE (ON-SITE)”form will be
                                    applied to rejected repairing for all out
                                    warranty jobs.
                                </span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <table
                    width="100%"
                    cellpadding="0"
                    cellspacing="0"
                    style="
            margin-top: 10px;
            border-top: solid 2px black;
            border-left: solid 2px black;
            border-bottom: solid 2px black;
            border-right: solid 2px black;
          "
                >
                    <tr style>
                        <td style="padding: 0px !important">
                            <table
                                cellpadding="0"
                                cellspacing="0"
                                style="width: 545px"
                            >
                                <tr>
                                    <td
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="
                      width: 200px;
                      padding-left: 10px;
                      font-size: 7pt;
                      font-weight: bold;
                    "
                                    >
                                        <div style="margin-top: 15px">
                                            <span
                                                style="font-size: 9pt; font-weight: bold"
                                                >For Customer’s
                                                Information:</span
                                            >
                                        </div>
                                    </td>
                                    <td cellpadding="0" cellspacing="0">
                                        <div style="margin-top: 15px">
                                            <span
                                                style="
                          font-size: 9pt;
                          text-decoration: underline;
                          font-weight: bold;
                          vertical-align: top;
                        "
                                                >Disclaimer Statement</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; font-weight: bold"
                                                >Data residing in your equipment
                                                could</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; font-weight: bold"
                                                >Be erased during the course of
                                                repair.</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; font-weight: bold"
                                                >Equipment will be returned with
                                                factory settings.</span
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <table cellpadding="0" cellspacing="0" style>
                                <tr>
                                    <td
                                        style="
                      font-size: 8pt;
                      padding-left: 10px;
                      line-height: 17px;
                    "
                                        cellpadding="0"
                                        cellspacing="0"
                                    >
                                        <div style="margin-top: 25px">
                                            <span
                                                style="font-size: 9pt; color: black"
                                            >
                                                While the HP Inc – Customer
                                                Service take precaution to avoid
                                                unnecessary erasure of data,
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; color: black"
                                            >
                                                You are advised to perform your
                                                own back-up. Before handing the
                                                equipment to us,
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; color: black"
                                            >
                                                You shall provide your own means
                                                of data recovery should any such
                                                data be lost in
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; color: black"
                                            >
                                                the course of repair. The HP Inc
                                                – Customer Service makes no
                                                warranties, expressed or
                                                implied,
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 9pt; color: black"
                                            >
                                                with regards to Preservation of
                                                your data, nor shall HP Inc be
                                                liable for any damages.
                                            </span>
                                        </div>
                                        <div>
                                            <span lang="th"
                                                >เรียน
                                                ลูกค้าผู้มีเกียรติทุกท่าน</span
                                            >
                                        </div>
                                        <div style="margin-top: 10px">
                                            <span
                                                lang="th"
                                                style="font-size: 8pt; color: black"
                                            >
                                                เรื่อง
                                                เอกสารขอสงวนสิทธิ์ในการให้บริการจัดเก็บข้อมูลของลูกค้า
                                            </span>
                                        </div>
                                        <div style="margin-top: 10px">
                                            <span
                                                style="padding-left: 40px; font-size: 8pt; color: black"
                                            >
                                                เนื่องด้วยฝ่ายบริการ เอชพี อิงค์
                                                มีความจำเป็นที่จะต้องป้องกัน
                                                และเพื่อเป็นการหลีกเลี่ยง
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                            >
                                                การสูญหายของข้อมูล
                                                รวมถึงโปรแกรมต่างๆ
                                                ของลูกค้าซึ่งอาจถูกลบ
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                                >ในระหว่างการดำเนินการซ่อมหากท่านมีความประสงค์ที่จะดำเนินการซ่อมผลิตภัณฑ์กับทางฝ่ายบริการฯ</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                                >จึงใคร่ขอแนะนำให้ลูกค้าดำเนินการจัดเก็บข้อมูลสำคัญรวมถึงโปรแกรมต่างๆ</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                                >ของท่านทุกท่านก่อนการซ่อมกับทางฝ่ายบริการ</span
                                            >
                                        </div>
                                        <div style="margin-top: 10px">
                                            <span
                                                style="padding-left: 40px; font-size: 8pt; color: black"
                                            >
                                                ทั้งนี้ทางฝ่ายบริการ เอชพี อิงค์
                                                ขอสงวนสิทธิ์ในการไม่รับประกัน
                                                หรือชดใช้
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                            >
                                                รวมถึงความรับผิดชอบต่อความเสียหายใดๆที่เกิดขึ้นในกรณีที่ข้อมูลลูกค้าสูญหาย
                                                หรือ
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="font-size: 8pt; color: black"
                                                >ถูกทำลายในระหว่างการดำเนินการซ่อม</span
                                            >
                                        </div>
                                        <div style="margin-top: 10px">
                                            <span
                                                style="font-size: 14px; font-weight: bold"
                                                >I understand and accept the
                                                above Disclaimer
                                                Statement.</span
                                            >
                                        </div>
                                        <div style="margin-bottom: 10px">
                                            <span lang="th"
                                                >ข้าพเจ้าเข้าใจและยอมรับในเงื่อนไขดังกล่าวข้างต้น</span
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td
                            style="
                border-left: solid 2px black;
                padding-left: 10px;
                padding-top: 10px;
                border-left: solid 2px black;
              "
                        >
                            <div style="margin-bottom: 25px">
                                <span
                                    style="word-wrap: break-word; text-indent: 5px"
                                    >Primary Email:</span
                                >
                            </div>
                            <div>
                                <span
                                    >__________________________________________@__________________________________________</span
                                >
                            </div>
                            <br />
                            <div>
                                <span
                                    style="word-wrap: break-word; text-indent: 4px"
                                    lang="th"
                                    >หากท่านได้รับแบบสำรวจความพึงพอใจสำหรับการบริการในครั้งนี้จาก</span
                                >
                            </div>
                            <div>
                                <span
                                    style="
                    word-wrap: break-word;
                    text-indent: 5px;
                    color: #0d62bf;
                    text-decoration: underline;
                  "
                                    >HPSupport@hp-feedback.com</span
                                >
                            </div>
                            <div>
                                <span
                                    style="word-wrap: break-word; text-indent: 5px"
                                    lang="th"
                                    >ขอความกรุณาแสดงความคิดเห็น</span
                                >
                            </div>
                            <div style="margin-top: 15px">
                                <span
                                    style="word-wrap: break-word; text-indent: 5px"
                                >
                                    If you receive a survey invitation from
                                    <span
                                        style="color: #0d62bf; text-decoration: underline"
                                        >HPSupport@hp-feedback.com,</span
                                    >
                                </span>
                            </div>
                            <div>
                                <span
                                    style="word-wrap: break-word; text-indent: 5px"
                                    >Please express your opinion.</span
                                >
                            </div>
                            <table
                                style="
                  margin-top: 15px;
                  border-top: outset 1px black;
                  border-left: outset 1px black;
                  border-right: outset 1px black;
                  border-bottom: outset 1px black;
                "
                                width="99%"
                            >
                                <tr>
                                    <td
                                        style="padding: 5px; font-weight: bold; font-size: 10px"
                                    >
                                        <div>
                                            <span
                                                style="
                          margin-left: 5px;
                          font-size: 12px;
                          color: black;
                          font-weight: bold;
                        "
                                            >
                                                จากประสบการณ์ของท่านมีความเป็นไปได้มากน้อยเพียงใด
                                                ที่ท่านจะแนะนำ HP
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="
                          margin-left: 5px;
                          font-size: 12px;
                          color: black;
                          font-weight: bold;
                        "
                                                >กับเพื่อนสมาชิกในครอบครัว หรือ
                                                ผู้ร่วมงาน</span
                                            >
                                        </div>
                                        <div>
                                            <span
                                                style="
                          margin-left: 5px;
                          font-size: 12px;
                          color: black;
                          font-weight: bold;
                        "
                                            >
                                                Based on your experience,how
                                                likely would you be to recomm
                                                end HP to a friend,
                                            </span>
                                        </div>
                                        <div>
                                            <span
                                                style="
                          margin-left: 5px;
                          font-size: 12px;
                          color: black;
                          font-weight: bold;
                        "
                                                >family member or
                                                colleague?</span
                                            >
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <br />
                            <img
                                src="../../../assets/odm/cso-img.png"
                                style="max-height: 100px; width: 600px"
                            />
                        </td>
                    </tr>
                </table>

                <table
                    cellpadding="0"
                    cellspacing="0"
                    style="margin-top: 5px; width: 100%"
                >
                    <tr width="50%">
                        <td
                            style="
                width: 46.5%;
                padding-left: 38px;
                border-top: solid 1.5px black;
                border-left: solid 1.5px black;
                padding-top: 5px;
              "
                        >
                            <span style="font-weight: bold"
                                >*Authorized Customer Signature</span
                            >
                            <span lang="th">(ลายเซ็นลูกค้าผู้มีอำนาจ)</span>
                        </td>
                        <td
                            style="
                width: 52.5%;
                padding-left: 85px;
                border-top: solid 1.5px black;
                border-right: solid 1.5px black;
                border-left: solid 2px black;
                padding-top: 5px;
                width: 410px;
              "
                        >
                            <span style="font-weight: bold"
                                >*Engineer Signature</span
                            >
                            <span lang="th">(ลายเซ็นพนักงาน)</span>
                        </td>
                    </tr>
                    <tr width="50%">
                        <td
                            style="
                padding-left: 16px;
                border-left: solid 1.5px black;
                padding-top: 15px;
                width: 400px;
              "
                        >
                            _____________________________________________________________________
                        </td>
                        <td
                            style="
                padding-left: 16px;
                border-left: solid 1.5px black;
                border-right: solid 1.5px black;
                border-left: solid 2px black;
                padding-top: 15px;
                width: 400px;
              "
                        >
                            _____________________________________________________________________
                        </td>
                    </tr>
                    <tr width="50%">
                        <td
                            style="
                padding-left: 80px;
                border-left: solid 1.5px black;
                padding-top: 15px;
                width: 400px;
              "
                        >
                            Date:________________________________________
                        </td>
                        <td
                            style="
                padding-left: 80px;
                border-right: solid 1.5px black;
                border-left: solid 2px black;
                padding-top: 15px;
                width: 400px;
              "
                        >
                            Date:________________________________________
                        </td>
                    </tr>
                    <tr>
                        <td
                            style="
                padding-left: 80px;
                border-left: solid 1.5px black;
                padding-top: 15px;
                border-bottom: solid 1.5px black;
                width: 400px;
              "
                        ></td>
                        <td
                            style="
                padding-left: 80px;
                border-right: solid 1.5px black;
                border-left: solid 2px black;
                padding-top: 15px;
                border-bottom: solid 1.5px black;
                width: 400px;
              "
                        ></td>
                    </tr>
                </table>

                <table
                    style="width: 100%; border: 1px black solid; margin-top: 200px"
                >
                    <tbody>
                        <tr>
                            <td
                                colspan="2"
                                style="
                  text-align: center;
                  font-size: 25px;
                  color: #36352f;
                  font-weight: bold;
                "
                            >
                                CE Bench/Onsite Check List & Customer
                                Satisfaction Audit
                                <label style="width: 40px"></label>
                                <img
                                    src="../../../assets/odm/HPBLUE.png"
                                    style="width: 70px; height: 60px; margin-top: 10px"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <label style="width: 10px"></label>
                                <label
                                    style="color: black; font-weight: bold; font-size: 17px"
                                    >Service Type :</label
                                >
                                <label style="width: 10px"></label>
                                <input
                                    type="checkbox"
                                    id="checkbox"
                                    style="border: 1px black solid; width: 20px; height: 20px"
                                />
                                <label style="width: 10px"></label>
                                <label
                                    for="checkbox"
                                    style="color: black; font-weight: bold; font-size: 17px"
                                    >Bench</label
                                >
                                <label style="width: 10px"></label>
                                <input
                                    type="checkbox"
                                    id="checkbox"
                                    style="border: 1px black solid; width: 20px; height: 20px"
                                />
                                <label style="width: 10px"></label>
                                <label
                                    for="checkbox"
                                    style="color: black; font-weight: bold; font-size: 17px"
                                    >Onsite</label
                                >
                            </td>
                        </tr>
                        <tr style>
                            <td colspan="2">
                                <table
                                    style="
                    border-collapse: collapse;
                    vertical-align: top;
                    margin-top: -100px;
                  "
                                    width="100%"
                                    cellpadding="0"
                                    cellspacing="0"
                                >
                                    <tr border="1">
                                        <td
                                            align="center"
                                            style="
                        width: 250px;
                        height: 50px;
                        border-style: solid;
                        border-width: 2px;
                        color: #574d52;
                        font-size: 15px;
                      "
                                        >
                                            <b>Devices</b>
                                        </td>
                                        <td
                                            align="center"
                                            style="
                        width: 275px;
                        height: 50px;
                        border-style: solid;
                        border-width: 2px;
                        color: #574d52;
                        font-size: 15px;
                      "
                                        >
                                            <b>Test Step</b>
                                        </td>
                                        <td
                                            align="center"
                                            style="
                        width: 275px;
                        height: 50px;
                        border-style: solid;
                        border-width: 2px;
                        color: #574d52;
                        font-size: 15px;
                      "
                                        >
                                            <b>Test Status</b>
                                        </td>
                                    </tr>
                                    <tr border="1" style="margin-left: 30px">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >CD/DVD WRITER</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Can read/write. Led is
                                                lighted.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >DVD/CD ROM</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Can read/write. Led is
                                                lighted.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>

                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >FlOPPY DRIVE</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Can read/write. Led is
                                                lighted.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >HARDDISK</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Resonable speed, Bad sector.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >DISPLAY CARD</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Standard 800X600 Flickering.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >SOUND CARD</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Music CD test.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >NETWORK CARD</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Can connect network.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >MODEM(INTERNAL)</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Dial up to ISP.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >INTERFACE PORT</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b></b>
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >PARALLEL PORT</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Test with a deskjet.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>

                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >COM PORT</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Test with mouse.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >USB PORT</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Keyboard/Mouse.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px">PS/2</b>
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Keyboard/Mouse.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >SPEAKER</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Sound.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >KEYBOARD</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Button test.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >MOUSE</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b></b>
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >POWER SUPPLY</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Bootup at least 5 times.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr border="1">
                                        <td
                                            class="textcolor"
                                            style="
                        width: 250px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >MOTHERBOARD</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <b style="margin-left: 5px"
                                                >Tattoo.</b
                                            >
                                        </td>
                                        <td
                                            class="textcolor"
                                            style="
                        width: 275px;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <center>
                                                <label
                                                    style="width: 10px; margin-top: 20px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Passed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>Failed /</label>
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <input
                                                    type="checkbox"
                                                    style="font-size: 20pt; width: 20px; height: 20px"
                                                />
                                                <label
                                                    style="width: 10px"
                                                ></label>
                                                <label>NA</label>
                                            </center>
                                        </td>
                                    </tr>
                                    <tr
                                        border="1"
                                        cellpadding="0"
                                        cellspacing="0"
                                        style="border-collapse: collapse"
                                    >
                                        <td
                                            valign="top"
                                            colspan="1"
                                            class="textcolor"
                                            style="
                        width: 100%;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <table>
                                                <tr>
                                                    <td
                                                        style="border-collapse: collapse; width: 250px"
                                                    >
                                                        <div
                                                            style="font-size: 20px"
                                                        >
                                                            <b
                                                                >Problem (case
                                                                not pass):</b
                                                            >
                                                        </div>
                                                        <br />
                                                        <p>
                                                            _____________________
                                                        </p>

                                                        <p
                                                            style="margin-top: 27px"
                                                        >
                                                            _____________________
                                                        </p>

                                                        <p
                                                            style="margin-top: 27px"
                                                        >
                                                            _____________________
                                                        </p>

                                                        <p
                                                            style="margin-top: 27px"
                                                        >
                                                            _____________________
                                                        </p>

                                                        <p
                                                            style="margin-top: 27px"
                                                        >
                                                            _____________________
                                                        </p>

                                                        <p
                                                            style="margin-top: 27px"
                                                        >
                                                            _____________________
                                                        </p>
                                                    </td>

                                                    <td></td>
                                                </tr>
                                            </table>
                                        </td>

                                        <td
                                            valign="top"
                                            colspan="1"
                                            class="textcolor"
                                            style="
                        width: 100%;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <table>
                                                <tr>
                                                    <td
                                                        style="border-collapse: collapse; width: 300px"
                                                    >
                                                        <div
                                                            style="font-size: 20px"
                                                        >
                                                            <b
                                                                >Collective
                                                                Active:</b
                                                            >
                                                        </div>
                                                        <br />
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Recheck</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Repair</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Change</label
                                                            >
                                                        </p>
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Others</label
                                                            >
                                                            <label
                                                                style="font-weight: bold"
                                                                >___________________________</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <label
                                                                style="font-weight: bold; margin-left: 20px"
                                                                >___________________________________</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <label
                                                                style="font-weight: bold; margin-left: 20px"
                                                                >_________________________________</label
                                                            >
                                                        </p>
                                                    </td>

                                                    <td></td>
                                                </tr>
                                            </table>
                                        </td>

                                        <td
                                            valign="top"
                                            colspan="1"
                                            class="textcolor"
                                            style="
                        width: 100%;
                        border-style: solid;
                        border-width: 2px;
                      "
                                        >
                                            <table>
                                                <tr>
                                                    <td
                                                        style="border-collapse: collapse; width: 300px"
                                                    >
                                                        <div
                                                            style="font-size: 20px"
                                                        >
                                                            <b
                                                                >Follow up
                                                                corrective
                                                                action:</b
                                                            >
                                                        </div>
                                                        <br />
                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Pass</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <input
                                                                type="checkbox"
                                                                style="
                                  font-size: 20.5px;
                                  width: 20px;
                                  height: 20px;
                                  margin-left: 20px;
                                "
                                                            />
                                                            <label
                                                                style="
                                  font-size: 20px;
                                  margin-left: 5px;
                                  font-weight: bold;
                                "
                                                                >Not pass
                                                                because_________</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <label
                                                                style="font-weight: bold; margin-left: 20px"
                                                                >_______________________________________</label
                                                            >
                                                        </p>
                                                        <p>
                                                            <label
                                                                style="
                                  font-weight: bold;
                                  margin-left: 20px;
                                  margin-top: 5px;
                                "
                                                                >_______________________________________</label
                                                            >
                                                        </p>

                                                        <p>
                                                            <label
                                                                style="
                                  font-weight: bold;
                                  margin-left: 20px;
                                  margin-top: 5px;
                                "
                                                                >_______________________________________</label
                                                            >
                                                        </p>
                                                        <p>
                                                            <label
                                                                style="font-weight: bold; margin-left: 5px"
                                                                >Audit:___________Date:___________</label
                                                            >
                                                        </p>
                                                    </td>

                                                    <td></td>
                                                </tr>
                                            </table>
                                        </td>

                                        <br />
                                        <br />
                                        <br />
                                    </tr>

                                    <tr>
                                        <td></td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td colspan="3">
                                            <label style="width: 10px"></label>
                                            <div style="margin-left: 10px">
                                                ........................................................................................................................................................................................................................................................................
                                            </div>
                                        </td>
                                    </tr>
                                    <br />

                                    <tr>
                                        <td colspan="3">
                                            <label style="width: 10px"></label>
                                            <p
                                                class="textcolor"
                                                style="
                          margin-left: 10px;
                          text-decoration: underline;
                          font-weight: bold;
                        "
                                            >
                                                Customer Satisfaction:
                                            </p>
                                        </td>
                                    </tr>
                                    <br />

                                    <tr>
                                        <td colspan="2">
                                            <div
                                                style="
                          margin-left: 10px;
                          border: 1px black solid;
                          height: 140px;
                          margin-top: 4px;
                        "
                                            ></div>
                                        </td>
                                        <td align="center" colspan="1">
                                            <br />
                                            <br />
                                            <br />
                                            <span style="pandding-left: 50px"
                                                >_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
                                                _ _ _</span
                                            >
                                            <br />
                                            <br />
                                            <p
                                                class="textcolor"
                                                style="font-size: 15px; font-weight: bold"
                                            >
                                                Signature's Customer/Front
                                                Counter
                                            </p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colspan="2" style></td>
                                        <td align="left" colspan="1">
                                            <p
                                                style="font-size: 15px; font-weight: bold"
                                                class="textcolor"
                                            >
                                                Date.
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table
                    width="100%"
                    style="
            border-collapse: collapse;
            border: 2px black solid;
            margin-top: 4px;
          "
                    border="2"
                >
                    <tr width="100%" align="right">
                        <td align="right">
                            <label style="color: black"
                                >FM-ODM01-01 Rev.0 Eff. 01 Feb 2021</label
                            >
                            <label style="width: 10px"></label>
                        </td>
                    </tr>
                </table>

                <table
                    width="100%"
                    style="border-collapse: collapse; border: 1px black solid"
                    border="2"
                >
                    <tr width="100%" align="right">
                        <td align="right">
                            <label>For Internal Use Only</label>
                            <label style="width: 10px"></label>
                        </td>
                    </tr>
                </table>

                <!-- <div style="margin:0px;">
          <span style="font-size:16px;color:black;width:350px;"
            >3rd Floor, 968 U Chu Liang Building,
          </span>
          <span
            style="font-size:16px;font-weight:bold;color:black;margin-left:30%"
            >CSO ID:
          </span>
      
        <div style="margin:0px;" class="dd">
          <span style="font-size:16px;color:black;width:350px;"
            >Rama 4 Road, Silom, Bangrak Bangkok
          </span>
          <span
            style="font-size:16px;font-weight:bold;color:black;margin-left:30%"
            >Tax No:
          </span>
        </div>
        <div style="margin:0px;">
          <span style="font-size:16px;color:black;width:350px;"
            >Thailand 10500
          </span>
        </div>

        <v-row>
          <v-col cols="12" class="pa-0">
            <div>
              <div v-text="playgroundText"></div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pa-0">
            <div>
              <div v-text="playgroundText"></div>
            </div>
          </v-col>
        </v-row>-->
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"
import VueHtmlToPaper from "vue-html-to-paper"

const options = {
    name: "_blank",
    specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}

export default {
    mounted() {
        this.getDetail()
    },
    ...mapMutations(["mutateMiniSidebar"]),
    methods: {
        print() {
            this.$htmlToPaper("printDiv")
        },
        async getDetail() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/casedetail/${this.$route.params.caseid}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.data_case = data
                this.data_case.subs.map((each) => {
                    if (each.subcase_id == this.$route.params.subcaseid) {
                        this.data_subcase = each
                    }
                })
                // for (let i = 0; i < this.data_subcase.parts.length; i++) {
                //      this.data_subcase.parts.push(each.project_id)
                // }
                this.waranty =
                    this.data_case.otc == "05K-Extended Warranty" ||
                    this.data_case.otc == "05K"
                        ? "* Support Pack / Carepaq"
                        : this.data_case.otc == "06M-Intl Re-repair" ||
                          this.data_case.otc == "06M"
                        ? "Re-repair ( no charge)"
                        : this.data_case.otc == "01-Trade" ||
                          this.data_case.otc == "01E"
                        ? "* Trade Call , No Warranty, No Contract"
                        : this.data_case.otc == "02N-Normal Warranty" ||
                          this.data_case.otc == "02N"
                        ? "* Warranty"
                        : ""
            } catch (error) {
                console.log(error)
            }
        },
    },
    data() {
        return {
            data_case: [],
            data_subcase: [],
            waranty: "",
        }
    },
}
</script>
<style scoped>
.spacing-playground .v-select .v-input__prepend-outer,
.spacing-playground .v-select .v-input__append-outer {
    margin-top: 0.55rem;
    margin-right: 0.2rem;
}
body {
    margin: 0 !important;
}
</style>
